import { useCallback, useRef } from "react";

import type { SignalType } from "app/pages/sales-intelligence/domain/signals/types/signal";

type SectionRefs = Partial<Record<SignalType, HTMLElement | null>>;
type SectionRefCallback = (element: HTMLElement | null) => void;

export const useAccountSignalSectionRefs = () => {
    const sectionRefs = useRef<SectionRefs>({});
    const refCallbacks = useRef<Partial<Record<SignalType, SectionRefCallback>>>({});

    const registerSectionRef = useCallback((signalType: SignalType): SectionRefCallback => {
        const existingCallback = refCallbacks.current[signalType];

        if (existingCallback) {
            return existingCallback;
        }

        const callback: SectionRefCallback = (element) => {
            sectionRefs.current[signalType] = element;
        };
        refCallbacks.current[signalType] = callback;

        return callback;
    }, []);

    const scrollToSignalType = useCallback((signalType: SignalType): void => {
        sectionRefs.current[signalType]?.scrollIntoView({ behavior: "smooth", block: "start" });
    }, []);

    return {
        registerSectionRef,
        scrollToSignalType,
    };
};
